import React from 'react';
import Ribbon from '../../Ribbon/Ribbon';
import s from './Gallery.module.css';

function Pictures({
  backgroundImage,
  // galleryImage,
  firstImageFromList,
  secondImageFromList,
  thirdImageFromList,
}) {
  return (
    <section className={s.section} id="gallery">
      <div
        className={s.div}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
        }}
      >
        <ul className={s.list}>
          <li className={s.item}>
            <img src={firstImageFromList} alt="product"></img>
            <img
              src={'/Images/borderFirstImageFromGallery.png'}
              className={s.bordered}
              alt="product"
            ></img>
          </li>
          <li className={s.item}>
            <img src={secondImageFromList} alt="product"></img>
          </li>
          <li className={s.item}>
            <img src={thirdImageFromList} alt="product"></img>
          </li>
        </ul>
      </div>

      {/* <img src={galleryImage} className={s.img}></img> */}
      <Ribbon />
    </section>
  );
}

export default Pictures;
